import { defineMessages } from 'react-intl';

export default defineMessages({
    error: {
        id: 'ml.reinstatement.common.views.ml-reinstatement-contact-us.An error has occurred, please try again later.',
        defaultMessage: 'An error has occurred, please try again later.'
    }
});
